import React from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'

export default function TierFeature({ name, help }) {
    return (
        <div className='quickFlex forceFlex' style={{ gap: 6, alignItems: 'center' }}>
            <Icons icon='tickCircle' color='var(--site-primary)' style={{ height: 16, width: 16 }} />
            <div className='featureName'>
                {name}
                {!!help && (
                    <Icons
                        icon='questionCircle'
                        color='var(--neutral-600)'
                        style={{ height: 16, width: 16 }}
                        data-tooltip-content={help}
                        data-tooltip-id={'upsellFeatureHelp' + name.replace(/\s+/g, '')}
                    />
                )}
            </div>
        </div>
    )
}
